import usePermittedQuery from '_api/queries/usePermittedQuery';
import { Message } from '_api/types';
import { ACCOUNT_TYPE } from '_constants';

export const GET_UNREAD_MESSAGES = 'get-unread-messages';

export const useGetUnreadMessage = () =>
  usePermittedQuery<Message[]>(
    [ACCOUNT_TYPE.THERAPIST],
    () => `/message/unread`,
    {},
    [GET_UNREAD_MESSAGES],
    {
      refetchOnWindowFocus: false,
    },
  );
